export const screenName = 'Task Add Note';
export const events = Object.freeze({
    saveNote: `${screenName} - Save Note`
});

export const metrics = Object.freeze({
    screenName,
    events
});
